export default __webpack_public_path__ + "static/media/Excel.9a5a7758.svg";